import React from "react";
import Modal from 'react-bootstrap/Modal'

import Div from "../common/Div"
import AsyncSelect from "../common/AsyncSelect"
import CustomDropzone from "../common/CustomDropzone"


import Notify from "../../../utils/Notify";
import General from "../../../utils/General";
import Backend from "../../../utils/Backend";
import Declarant from "../../../utils/Declarant";

import PartyModal from "../modal/Party";
import MappingsModal from "../modal/Mappings";

import Select from "../common/Select";
import Flatpickr from "react-flatpickr";
import moment from "moment/moment";
import CodeInput from "../item/CodeInput";

const PARSERS = [
  {
    label: 'AIS',
    value: 'platform',
  },
  {
    label: 'AES',
    value: 'aes_platform',
  },
  {
    label: 'CDS Import',
    value: 'cds_platform',
  },
  {
    label: 'CDS Export',
    value: 'cds_export_platform',
  },
  {
    label: 'CDS BIRDS',
    value: 'birds',
  },
  {
    label: 'DECO / DMS',
    value: 'nhd_platform',
  },
  {
    label: 'ICS2',
    value: 'ics2_platform',
  },
]
export default class Upload extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      parser: "platform",
      show: props.show,
      data: {},
      f34Data: {},
      template: null
    }
  }

  _isFormValid(){
    let {
      file,
      client,
      parser,
      template,
    } = this.state

    let error = null
    if(!client){
      error = "Please select a client"
    }
    else if(!file){
      error = "Please upload a file"
    }
    else if(!parser){
      error = "Please specify the declaration type"
    }
    else if(!template){
      error = "Please select a template declaration"
    }

    if(error){
      Notify.error(error)
    }

    return error == null

  }

  _save(){
    if(!this._isFormValid()){
      return
    }

    let {
      file,
      client,
      parser,
      mapping,
      f34Data,
      template,
      externalId,
      h1FallbackTemplate,
    } = this.state

    let data = {
      parser,
      file: file.id,
      client: client.id,
      external_id: externalId,
      template: template.id,
      declarant: Declarant.getDeclarantId(template.form)
    }

    if(h1FallbackTemplate){
      data.h1_fallback_template = h1FallbackTemplate.id
    }

    if(template.form.subtype === "G4G3"){
      data.parser = "g4_g3"
    }
    if(template.form.subtype === "F34"){
      data = {
        ...data,
        ...f34Data
      }

      if(data.active_transport_nationality){
        data.active_transport_nationality = data.active_transport_nationality.id
      }

      if(data.passive_transport_nationality){
        data.passive_transport_nationality = data.passive_transport_nationality.id
      }
    }

    if(mapping){
      data.mapping = mapping.id
    }


    this.setState({ loading: true })
    Backend.createUpload(data)
    .then(bulkUpload => {
      this.setState({ file: null, loading: false }, () => this.props.onUploaded())
      Notify.success("File uploaded successfully, your declarations will become available as they are processed")
    }).catch(e => {
      Notify.error(e.message)
      this.setState({ loading: false })
    })
  }

  _renderF34Fields(){
    const { f34Data } = this.state
    let {
      passive_transport_number,
      passive_transport_nationality,
      active_transport_number,
      active_transport_nationality,
      issue_date,
      departure_datetime,
      arrival_datetime,
    } = f34Data

    return (
      <>
        <div className="form-group row mb-5">
          <label className="form-label ">Passive Means of Transport Number (Trailer Number/Vehicle Number)"</label>
          <input
            type="text"
            className="form-control"
            placeholder="Passive Means of Transport Number (Trailer Number/Vehicle Number)"
            value={passive_transport_number}
            onChange={e => {
              f34Data.passive_transport_number = e.target.value || null
              this.setState({f34Data})
            }}
          />
        </div>
        <div className="form-group row">
          <label className="form-label ">Passive Means of Transport Nationality</label>
          <CodeInput
            listKey={"CountryCodes_ICS2"}
            value={passive_transport_nationality}
            editable={true}
            showLabel={false}
            placeholder={"Passive Means of Transport Nationality"}
            onSelected={option => {
              f34Data.passive_transport_nationality = option
              this.setState({f34Data})
            }}
          />
        </div>
        <div className="form-group row mb-5">
          <label className="form-label ">Active Means of Transport Number (IMO Reference)</label>
          <input
            type="text"
            className="form-control"
            placeholder="Active Means of Transport Number (IMO Reference)"
            value={active_transport_number}
            onChange={e => {
              f34Data.active_transport_number = e.target.value || null
              this.setState({f34Data})
            }}
          />
        </div>
        <div className="form-group row mb-5">
          <label className="form-label ">Active Means of Transport Nationality</label>
          <CodeInput
            listKey={"CountryCodes_ICS2"}
            value={active_transport_nationality}
            editable={true}
            showLabel={false}
            placeholder={"Active Means of Transport Nationality"}
            onSelected={option => {
              f34Data.active_transport_nationality = option
              this.setState({f34Data})
            }}
          />
        </div>
        <div className="form-group row mb-5">
          <label className="form-label ">Issue Date</label>
          <Flatpickr
            value={issue_date ? moment(issue_date).format("DD-MM-YYYY") : null}
            className="form-control"
            placeholder="Issue Date"
            options={{
              enableTime: true,
              noCalendar: false,
              dateFormat: "d-m-Y H:i",
            }}
            onChange={(dates) => {
              f34Data.issue_date = dates[0]
              this.setState({f34Data})
            }}
          />
        </div>
        <div className="form-group row mb-5">
          <label className="form-label ">Date & Time of Departure</label>
          <Flatpickr
            value={departure_datetime ? moment(departure_datetime).format("DD-MM-YYYY HH:mm") : null}
            className="form-control"
            placeholder="Date & Time of Departure"
            options={{
              enableTime: true,
              noCalendar: false,
              dateFormat: "d-m-Y H:i",
            }}
            onChange={(dates) => {
              f34Data.departure_datetime = dates[0]
              this.setState({f34Data})
            }}
          />
        </div>
        <div className="form-group row mb-5">
          <label className="form-label ">Estimated Date & Time of Arrival</label>
          <Flatpickr
            value={arrival_datetime ? moment(arrival_datetime).format("DD-MM-YYYY HH:mm") : null}
            className="form-control"
            placeholder="Estimated Date & Time of Arrival"
            options={{
              enableTime: true,
              noCalendar: false,
              dateFormat: "d-m-Y H:i",
            }}
            onChange={(dates) => {
              f34Data.arrival_datetime = dates[0]
              this.setState({f34Data})
            }}
          />
        </div>
      </>
    )
  }

  _renderContent() {
    let {
      client,
      parser,
      mapping,
      csvFile,
      template,
      externalId,
      h1FallbackTemplate,
    } = this.state

    let declarationFilter = `template=true`
    if (parser === "birds") {
      declarationFilter += `&form_subtype=BIRDS`
    } else if (parser === "cds_platform") {
      declarationFilter += `&form_types=cds&form_subtypes=H1`
    } else if (parser === "cds_export_platform") {
      declarationFilter += `&form_types=cds&form_subtypes=B1`
    } else if (parser === "aes_platform") {
      declarationFilter += `&form_types=aes&form_subtypes=B1`
    } else if (parser === "nhd_platform") {
      declarationFilter += `&form_types=nhd&form_subtypes=H1,H7`
    }
    else if(parser === "ics2_platform"){
      declarationFilter += `&form_types=ics2`
    }
    else{
      declarationFilter += `&form_types=ais&form_subtypes=H1,H7,G4G3`
    }

    return (
      <>
        <div className="fv-row mt-10 mb-10 fv-plugins-icon-container fv-plugins-bootstrap5-row-valid">
          <div className="dropzone dropzone-default dropzone-no-border">
            <CustomDropzone
              deletable={true}
              fileTypes={['.csv', '.xlsx']}
              onUploaded={file => {
                this.setState({file})
              }}
              onBeforeUpload={rawFile => {
                this.setState({csvFile: rawFile})
              }}
              onDelete={() => {
                this.setState({file: null})
              }}
            />
          </div>
        </div>

        <div className="form-group row mb-5">
          <label className="form-label ">Client</label>
          <AsyncSelect
            placeholder={"Please select a Client"}
            endpoint={window.Api.Parties}
            orderBy={"name"}
            filter={`type=client`}
            isClearable={true}
            creatable={true}
            className={'custom-async-select__container'}
            classNamePrefix={'custom-async-select'}
            value={General.getSingleAsyncOption(client)}
            getOptions={options => {
              return options.map(option => ({
                value: option.id,
                label: option.name,
                data: option
              }))
            }}
            onSelected={client => {
              this.setState({
                client
              })
            }}
            onCreated={(option) => {
              let client = option.value;
              this.setState({
                client,
                showPartyModal: true,
              });
            }}
          />
        </div>

        <div className="form-group row mb-5">
          <label className="form-label ">System</label>
          <Select
            value={parser ? parser : null}
            options={PARSERS}
            placeholder="Select A System"
            getOptionLabel={option => option.label}
            getOptionValue={option => option.value}
            className="form-control h-auto border-0 form-control-solid c-selectbox"
            onSelected={option => {
              this.setState({parser: option.value, template: null, h1FallbackTemplate: null})
            }}
          />
        </div>

        <div className="form-group row mb-5">
          <label className="form-label ">Declaration</label>
          <AsyncSelect
            key={declarationFilter}
            placeholder={"Please select a template"}
            endpoint={window.Api.Submissions}
            orderBy={"name"}
            filter={declarationFilter}
            isClearable={false}
            className={'custom-async-select__container'}
            classNamePrefix={'custom-async-select'}
            value={General.getSingleAsyncOption(template)}
            getOptions={options => {
              return options.map(option => ({
                value: option.id,
                label: option.name,
                data: option
              }))
            }}
            onSelected={template => {
              if (template?.form.subtype !== "H7") {
                h1FallbackTemplate = null
              }
              this.setState({
                template,
                h1FallbackTemplate
              })
            }}
          />
        </div>

        {template?.form.subtype === "H7" &&
          <div className="form-group row mb-5">
            <label className="form-label ">H1 Fallback Declaration</label>
            <AsyncSelect
              placeholder={"Please select a template"}
              endpoint={window.Api.Submissions}
              orderBy={"name"}
              filter={`template=true&form_subtype=H1`}
              isClearable={false}
              className={'custom-async-select__container'}
              classNamePrefix={'custom-async-select'}
              value={General.getSingleAsyncOption(h1FallbackTemplate)}
              getOptions={options => {
                return options.map(option => ({
                  value: option.id,
                  label: option.name,
                  data: option
                }))
              }}
              onSelected={h1FallbackTemplate => {
                this.setState({
                  h1FallbackTemplate
                })
              }}
            />
            <span className="text-muted">The H1 declaration used if an item is prohibited on the H7.</span>
          </div>
        }

        { (template && csvFile) &&
          <div className="form-group row mb-5">
            <label className="form-label ">Mapping</label>
            <AsyncSelect
              placeholder={"Please select a mapping"}
              endpoint={window.Api.BulkUploadMappings}
              orderBy={"name"}
              filter={`form=${template.form.id}`}
              isClearable={true}
              creatable={true}
              className={'custom-async-select__container'}
              classNamePrefix={'custom-async-select'}
              value={General.getSingleAsyncOption(mapping)}
              getOptions={options => {
                return options.map(option => ({
                  value: option.id,
                  label: option.name,
                  data: option
                }))
              }}
              onSelected={mapping => {
                this.setState({
                  mapping
                })
              }}
              onCreated={() => {
                this.setState({
                  showMappingsModal: true,
                });
              }}
            />
            <span className="text-muted">Select or create a mapping if uploading your own CSV.</span>
          </div>
        }

        { template?.form.subtype === "F34" && this._renderF34Fields()}

        <div className="form-group row mb-5">
          <label className="form-label ">Reference</label>
          <input
            type="text"
            className="form-control"
            placeholder="Reference"
            value={externalId}
            onChange={e => {
              externalId = e.target.value || null
              this.setState({externalId})
            }}
          />
        </div>
      </>
    )
  }

  render() {
    let {
      show,
      parser,
      loading,
      csvFile,
      template,
      showPartyModal,
      showMappingsModal,
    } = this.state

    return (
      <>
        <Modal
          show={show}
          onHide={() => this.props.onHide()}
          className={'sub-modal'}
          dialogClassName={"modal-40"}
        >
          <Modal.Header closeButton>
            <Modal.Title>Upload File</Modal.Title>
          </Modal.Header>

          <Modal.Body>

            <Div disabled={loading}>

              {this._renderContent()}

            </Div>

          </Modal.Body>

          <Modal.Footer>
            <button
              type="button"
              className="btn btn-light"
              data-bs-dismiss="modal"
              disabled={loading}
              onClick={() => this.props.onHide()}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              data-bs-dismiss="modal"
              disabled={loading}
              onClick={() => this._save()}
            >
            Save
            </button>
          </Modal.Footer>

        </Modal>

        {
          showPartyModal && (
            <PartyModal
              name={"client"}
              show={showPartyModal}
              forcedPartyType={"client"}
              onHide={() => this.setState({ showPartyModal: false })}
              onSubmit={(client) => {
                this.setState({ showPartyModal: false, client });
              }}
            />
          )
        }

        { (showMappingsModal && csvFile) && (
            <MappingsModal
              parser={parser}
              csvFile={csvFile}
              form={template.form}
              show={showMappingsModal}
              onHide={() => this.setState({ showMappingsModal: false })}
              onCreated={(mapping) => {
                this.setState({ showMappingsModal: false, mapping });
              }}
            />
          )
        }
      </>
    )
  }

}
